import { render, staticRenderFns } from "./UkrTreasuresTableUser.vue?vue&type=template&id=812698d6&scoped=true"
import script from "./UkrTreasuresTableUser.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812698d6",
  null
  
)

export default component.exports